import {
    FACILITIES_TABLE_ID,
    LOCALE_TYPE_AREA,
    LOCALE_TYPE_BUILDING,
    LOCALE_TYPE_REGION,
    LOCALE_TYPE_ROOM
} from "constants/facilities_constants";

export function getSelectedFacilityType(facilityStoreValue) {
    const regionId = facilityStoreValue.region.id;
    const buildingId = facilityStoreValue.building.id;
    const areaId = facilityStoreValue.area.id;
    const roomId = facilityStoreValue.room.id;

    if (!_.isEmpty(roomId)) {
        return LOCALE_TYPE_ROOM;
    } else if (!_.isEmpty(areaId)) {
        return LOCALE_TYPE_AREA;
    } else if (!_.isEmpty(buildingId)) {
        return LOCALE_TYPE_BUILDING;
    } else if (!_.isEmpty(regionId)) {
        return LOCALE_TYPE_REGION;
    } else {
        return null;
    }
}

export function getClosestSelectedFacilityId(facilityStoreValue) {
    const selectedFacility = facilityStoreValue[getSelectedFacilityType(facilityStoreValue)];

    if (selectedFacility === undefined) {
        return null;
    } else {
        return selectedFacility.id;
    }
}

export function getSelectedFacilityName(facilityStoreValue) {
    const selectedFacility = facilityStoreValue[getSelectedFacilityType(facilityStoreValue)];

    if (selectedFacility === undefined) {
        return null;
    } else {
        return selectedFacility.name;
    }
}

export function getCurrentlyDisplayedFacilityType(facilityStoreValue) {
    if (facilityStoreValue === undefined) {
        return null;
    }

    const regionId = facilityStoreValue.region.id;
    const buildingId = facilityStoreValue.building.id;
    const areaId = facilityStoreValue.area.id;
    const roomId = facilityStoreValue.room.id;

    if (_.isEmpty(regionId) && _.isEmpty(buildingId) && _.isEmpty(areaId) && _.isEmpty(roomId)) {
        return LOCALE_TYPE_REGION;
    } else if (!_.isEmpty(regionId) && _.isEmpty(buildingId) && _.isEmpty(areaId) && _.isEmpty(roomId)) {
        return LOCALE_TYPE_BUILDING;
    } else if (!_.isEmpty(regionId) && !_.isEmpty(buildingId) && _.isEmpty(areaId) && _.isEmpty(roomId)) {
        return LOCALE_TYPE_AREA;
    } else if (!_.isEmpty(regionId) && !_.isEmpty(buildingId) && !_.isEmpty(areaId) && _.isEmpty(roomId)) {
        return LOCALE_TYPE_ROOM;
    } else {
        throw new Error('Unable to determine what facility is selected');
    }
}

/**
 * Get the argus--table controller for the facilities table
 */
function _getArgusTable() {
    const el = document.getElementById(FACILITIES_TABLE_ID);
    if (!el || !window.Stimulus) return null;
    return window.Stimulus.getControllerForElementAndIdentifier(el, 'argus--table');
}

export function addItemToTable(localeType, localeId, localeName) {
    const argusTable = _getArgusTable();
    if (argusTable) {
        argusTable.appendData([{
            id: localeId,
            name: localeName,
            localeType: localeType,
        }]);
        return;
    }
}

export function removeItemFromTable(localeId) {
    const argusTable = _getArgusTable();
    if (argusTable) {
        argusTable.removeRow('id', localeId);
        return;
    }
}

export function updateItemInTable(localeType, localeId, localeName) {
    const argusTable = _getArgusTable();
    if (argusTable) {
        argusTable.updateRow(localeId, { name: localeName });
        return;
    }
}
